module.exports = __webpack_public_path__ + "media/images/play-785bb7fe4a526a42aec22d3126480e24.svg";